var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBinance(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 69.388,
    height: 40.876,
    viewBox: "0 0 69.388 40.876",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #1228f3;\n      }\n\n      .cls-2 {\n        clip-path: url(#clip-path);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16612",
    "data-name": "Rectangle 16612",
    className: "cls-1",
    width: 69.388,
    height: 17.985
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "binace",
    transform: "translate(1049 -4409)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46532",
    "data-name": "Group 46532",
    transform: "translate(-1049 4431.892)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46524",
    "data-name": "Group 46524",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46523",
    "data-name": "Group 46523",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_99241",
    "data-name": "Path 99241",
    className: "cls-1",
    d: "M65.121,27.547h4.425a3.414,3.414,0,0,1,2.488.834,2.191,2.191,0,0,1,.656,1.609v.03a2.376,2.376,0,0,1-.1.715,3.3,3.3,0,0,1-.268.566,2.167,2.167,0,0,1-.387.432,3.388,3.388,0,0,1-.477.328,3.174,3.174,0,0,1,1.3.849,2.167,2.167,0,0,1,.477,1.475v.03a2.487,2.487,0,0,1-.253,1.132,2.076,2.076,0,0,1-.715.8,3.427,3.427,0,0,1-1.132.492,6.346,6.346,0,0,1-1.46.164h-4.53V27.547Zm3.993,3.829a2.125,2.125,0,0,0,1.1-.238.828.828,0,0,0,.4-.76v-.03a.814.814,0,0,0-.358-.715,1.8,1.8,0,0,0-1.028-.253H67.162v2h1.952m.551,3.8a2.024,2.024,0,0,0,1.088-.253.852.852,0,0,0,.4-.775v-.03a.861.861,0,0,0-.373-.745,2.028,2.028,0,0,0-1.192-.283H67.162v2.086Zm6.258-7.629h2.25v9.447h-2.25Zm5.409,0h1.952L87.8,33.373V27.547h2.086v9.447h-1.8l-4.664-6v6H81.332Zm14.8,0h1.892l4.008,9.447H99.883l-.849-2.1H95.085l-.849,2.1h-2.1Zm2.161,5.528-1.237-3.04-1.237,3.04Zm5.99-5.528h1.952l4.515,5.826V27.547h2.086v9.447h-1.8l-4.664-6v6h-2.086Zm16.256,9.462a5.183,5.183,0,0,1-2-.387,4.926,4.926,0,0,1-1.594-1.043,4.871,4.871,0,0,1-1.416-3.487v-.03a4.858,4.858,0,0,1,.373-1.922,4.825,4.825,0,0,1,2.652-2.652,5.433,5.433,0,0,1,2.056-.387,6.542,6.542,0,0,1,1.252.1,6.421,6.421,0,0,1,1.028.3,4.609,4.609,0,0,1,.849.462,7.068,7.068,0,0,1,.73.6L123.1,30.11a5.353,5.353,0,0,0-1.162-.79,2.938,2.938,0,0,0-1.326-.283,2.617,2.617,0,0,0-1.132.238,2.735,2.735,0,0,0-.894.641,2.984,2.984,0,0,0-.581.954,3.286,3.286,0,0,0-.209,1.162v.03A3.286,3.286,0,0,0,118,33.224a2.866,2.866,0,0,0,1.475,1.609,2.78,2.78,0,0,0,1.147.238,3.153,3.153,0,0,0,1.416-.3,5.117,5.117,0,0,0,1.147-.82l1.371,1.356a6.882,6.882,0,0,1-.775.715,4.78,4.78,0,0,1-.879.536,5.164,5.164,0,0,1-1.058.343,9,9,0,0,1-1.311.1m6.243-9.462h7.137v1.848h-5.081v1.922h4.47v1.848h-4.47v1.982h5.141v1.848h-7.2Z",
    transform: "translate(-64.587 -23.062)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_46531",
    "data-name": "Group 46531",
    transform: "translate(-1024.927 4409)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_99240",
    "data-name": "Path 99240",
    className: "cls-1",
    d: "M11,17.71,6.449,13.2,3.843,15.827l7.172,7.134,7.172-7.134L15.542,13.2ZM0,11.471l2.435,2.435L4.87,11.471,2.435,9.036Zm16.893,0,2.435,2.435,2.435-2.435L19.327,9.036ZM11,0,3.8,7.134,6.449,9.759,11,5.25l4.547,4.508,2.644-2.625Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_99251",
    "data-name": "Path 99251",
    className: "cls-1",
    d: "M49.374,33.733h0l-2.587-2.587-1.9,1.9-.228.228-.457.457,2.587,2.587Z",
    transform: "translate(-35.792 -22.547)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBinance);
export default __webpack_public_path__ + "static/media/binance.a9d73e865a6e5ca13e48e3b615bb0191.svg";
export { ForwardRef as ReactComponent };